import { render, staticRenderFns } from "./full_amount_with_gifts.vue?vue&type=template&id=5343e746&scoped=true"
import script from "./full_amount_with_gifts.vue?vue&type=script&lang=js"
export * from "./full_amount_with_gifts.vue?vue&type=script&lang=js"
import style0 from "./full_amount_with_gifts.vue?vue&type=style&index=0&id=5343e746&prod&lang=scss&scoped=true"
import style1 from "./full_amount_with_gifts.vue?vue&type=style&index=1&id=5343e746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343e746",
  null
  
)

export default component.exports